export const ChevronLeft = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={10} height={10} viewBox="0 0 10 11" fill="none">
    <path d="M7.08594 10.1835L3.07552 5.60014L7.08594 1.0168" stroke="black" strokeLinecap="round"/>
  </svg>
)
